module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white-overlay"
  }, [_c('spinner', {
    attrs: {
      "size": _vm.size || "big",
      "message": _vm.message || "Loading..."
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a852b990"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingOverlay.vue
// module id = 568
// module chunks = 0